import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'
import { CompareBarVehicle } from '../provider/compare-bar-provider.types'

export const compareCtaClickEvent = (
  comparisonVehicles: CompareBarVehicle[],
): TrackingEvent => ({
  eventName: 'compare-cta-click',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'Compare',
      action: 'Compare Cars',
      label: 'Clickthrough',
      value: comparisonVehicles
        .map((vehicle) => `${vehicle.vehicleTitle}`)
        .join(','),
    },
  },
})

export const compareVehicleRemovalEvent = (
  vehicleMake: string,
  vehicleModel: string,
  comparisonVehicles: CompareBarVehicle[],
): TrackingEvent => ({
  eventName: 'compare-vehicle-removal',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'Compare',
      action: 'Remove Vehicle - compare bar',
      label: vehicleModel,
      type: vehicleMake,
      value: comparisonVehicles.length - 1,
    },
  },
})

export const compareBarDrawerInteractionEvent = (open: boolean) => ({
  eventName: 'compare-bar-drawer-interaction',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'Compare',
      action: open ? 'Open Drawer' : 'Close Drawer',
      label: '',
      type: '',
      value: '',
    },
  },
})

export const compareMaxNumberOfVehicles = (maxNumberOfItems: number) => ({
  eventName: 'compare-max-number-of-vehicles',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'Compare',
      action: 'Max cars alert',
      value: maxNumberOfItems,
      type: '',
      label: '',
    },
  },
})

type ClickCompareVehicleProps = {
  action: 'Add Vehicle' | 'Remove Vehicle'
  make: string
  model: string
  value: number
}

export const clickCompareVehicle = ({
  action,
  make,
  model,
  value,
}: ClickCompareVehicleProps) => ({
  eventName: 'click-compare-vehicle',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'Compare',
      action,
      type: make,
      label: model,
      value,
    },
  },
})
